import { WbTable } from '@agilelab/plugin-wb-platform';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { Test } from '../types';
import { TaskDrawer } from './TaskDrawer/TaskDrawer';
import { TestHistoryEmptyState } from './TestHistoryEmptyState';
import { format, parseISO } from 'date-fns';
import { TestResults } from './TestResults';
import { TaskDisclosure } from './TaskDisclosure';
import { TestStatusColumn } from './TestStatus';

export function TestHistory() {
  const {
    testsState,
    testPagination,
    tests,
    onTestPageChange,
    onTestChangeRowsPerPage,
    selectedTask,
    setSelectedTask,
    monacoEditorRef,
  } = useEditorPageContext();

  if (!tests.length) return <TestHistoryEmptyState />;

  return (
    <>
      <WbTable<Test>
        stickyHeader
        renderRowDetail={test => <TaskDisclosure test={test} />}
        components={{
          tableLoader: {
            loading: testsState.loading,
          },
          tableContent: {
            getRowId: test => test.id,
            rows: tests,
            columns: [
              {
                headerName: 'Status',
                field: 'status',
                width: 50,
                minWidth: 50,
                resizable: false,
                fieldRender: test => <TestStatusColumn test={test} />,
              },
              {
                headerName: 'ID / Date',
                field: 'startDate',
                fieldRender: test =>
                  format(parseISO(test.startDate), 'yyyy/MM/dd HH:mm:ss'),
              },
              {
                uniqueFieldId: 'results',
                headerName: 'Results',
                fieldRender: test => <TestResults test={test} />,
              },
            ],
          },
        }}
        pagination={{
          rowsPerPageOptions: [5, 10, 25],
          count: testsState.value?.page?.count || 0,
          limit: testPagination.limit,
          offset: testPagination.offset,
          onPageChange: onTestPageChange,
          onRowsPerPageChange: onTestChangeRowsPerPage,
        }}
        styles={{
          container: { height: '100%', flex: '1 1 0' },
        }}
      />

      <TaskDrawer
        task={selectedTask}
        open={Boolean(selectedTask)}
        onClose={() => {
          setSelectedTask(null);
          monacoEditorRef.current?.applyDecorations(
            undefined,
            undefined,
            'white',
          );
        }}
      />
    </>
  );
}
